export default "__VITE_ASSET__DtEk6OAr__"